import React, { Component } from "react";
import { Item as MenuItem } from "rc-menu";
import Slider, { createSliderWithTooltip } from "rc-slider";
import { Vector as VectorLayer } from "ol/layer.js";
import "rc-slider/assets/index.css";

import * as helpers from "../../../../helpers/helpers";
import Portal from "../../../../helpers/Portal.jsx";
import FloatingMenu, {
  FloatingMenuItem,
} from "../../../../helpers/FloatingMenu.jsx";
import * as TOCHelpers from "./TOCHelpers.jsx";
import LayerInfoApp from "../../../../layerInfo/App";

const EXCLUDED_ATT_TAB = ["Katastrálna mapa (parcely C)", "Mapa určeného operátu (parcely E)", "Modernizácia závlah", "Závlahové stavby", "Odvodňovacie stavby", "Katastrálna mapa - inverzná (parcely C)", "Mapa určeného operátu - inverzná (parcely E)"];
class LayerOptionsMenu extends Component {
  constructor(props) {
    super(props);
    this.currentScroll = 0;
    this.state = {};
  }

  // OPACITY SLIDER FOR EACH LAYER
  onSliderChange = (opacity, layerInfo) => {
    layerInfo.layer.setOpacity(opacity);
    //this.currentScroll = document.getElementById(this.virtualId).scrollTop;
  };
  // OPACITY SLIDER AFTER COMPLETE
  onSliderAfterChange = (opacity, layerInfo) => {
    //document.getElementById(this.virtualId).scrollTop = this.currentScroll;
    layerInfo.opacity = opacity;
    this.props.onLayerChange(layerInfo, layerInfo.group);
  };

  zoomToVisibleScale = (layerInfo) => {
    const scales = [
      1155581, 577791, 288895, 144448, 72224, 36112, 18056, 9028, 4514, 2257,
      1128, 564,
    ];

    const scale = helpers.getMapScale();
    let minScale = 0;
    let maxScale = 100000000000;
    if (layerInfo.minScale !== undefined) minScale = layerInfo.minScale;
    if (layerInfo.maxScale !== undefined) maxScale = layerInfo.maxScale;

    if (scale >= minScale && scale <= maxScale) {
      helpers.showMessage(
        "Priblížiť na viditeľnú mierku",
        "Vrstva je už viditeľná v tejto mierke."
      );
      return;
    }

    if (scale < minScale) {
      const flipped = scales.reverse();
      let index = 20;
      flipped.forEach((scaleItem) => {
        if (scaleItem >= minScale) {
          window.map.getView().setZoom(index);
          return;
        }
        index--;
      });
    } else if (scale > maxScale) {
      let index = 9;
      scales.forEach((scaleItem) => {
        if (scaleItem <= maxScale) {
          window.map.getView().setZoom(index);
          return;
        }
        index++;
      });
    }
  };

  onMenuItemClick = (action, layerInfo) => {
    switch (action) {
      case "sc-floating-menu-metadata":
        if (
          layerInfo.metadataUrl === undefined ||
          layerInfo.metadataUrl === null
        )
          return;
        if (layerInfo.metadataUrl.endsWith("f=json"))
          helpers.showURLWindow(
            window.config.toc.layerInfoURL + layerInfo.metadataUrl
          );
        else
          TOCHelpers.getLayerInfo(layerInfo, (result) => {
            if (helpers.isMobile()) {
              window.emitter.emit("setSidebarVisiblity", "CLOSE");
              helpers.showWindow(
                <LayerInfoApp
                  layerURL={result.featureType.fullUrl}
                  params={result.requestParams}
                />
              );
            } else {
              helpers.showWindow(
                <LayerInfoApp
                  layerURL={result.featureType.fullUrl}
                  params={result.requestParams}
                />
              );
            }
          });
        helpers.addAppStat("Metadata", layerInfo.name);
        break;
      case "sc-floating-menu-zoom-to-layer":
        // ak je to layerGrop  
        if (['modernizacia_zavlah', 'odvodnovacie_stavby', 'zavlahove_stavby'].includes(layerInfo.name)) {
          // console.log('this is a LayerGroup');
          TOCHelpers.getLayerGroupInfo(layerInfo).then((result) => {

            const boundingBox = result.layerGroup.bounds;

            const extent = [
              boundingBox.minx,
              boundingBox.miny,
              boundingBox.maxx,
              boundingBox.maxy,
            ];
            window.map
              .getView()
              .fit(extent, window.map.getSize(), { duration: 1000 });
          }
          );
        }
        // ak je to Vektorova vrstva - featureType alebo rastrova vrstva - coverage
        else if (
          layerInfo.metadataUrl !== undefined &&
          layerInfo.metadataUrl !== null
        ) {
          TOCHelpers.getLayerInfo(layerInfo, (result) => {
            const boundingBox = result.featureType.nativeBoundingBox ? result.featureType.nativeBoundingBox : result.coverage.nativeBoundingBox;

            const extent = [
              boundingBox.minx,
              boundingBox.miny,
              boundingBox.maxx,
              boundingBox.maxy,
            ];
            window.map
              .getView()
              .fit(extent, window.map.getSize(), { duration: 1000 });
          });


        } else {
          console.log('ELSE layerinfo', layerInfo);
          const layerExtent = layerInfo.layer.getSource().getExtent();
          if (layerExtent !== undefined) {
            window.map
              .getView()
              .fit(layerExtent, window.map.getSize(), { duration: 1000 });
          }
        }
        break;
      case "sc-floating-menu-zoom-to-layer-visible":
        this.zoomToVisibleScale(layerInfo);
        break;
      case "sc-floating-menu-remove-layer":
        this.props.onRemoveLayer(layerInfo.name, layerInfo.group, () => { });
        break;
      case "sc-floating-menu-attribute-table":
        console.log("layerInfo", layerInfo);
        if (layerInfo.noAttributeTable)
          helpers.showMessage(
            "Oznámenie",
            "Atribútová tabuľka je pre túto vrstvu nedostupná."
          );
        else {
          window.emitter.emit(
            "openAttTab",
            layerInfo.serverUrl,
            layerInfo.name,
            undefined,
            layerInfo.displayName,
            false,
            undefined,
            "toc",
            null,
            false //render
          );
        }
        break;
      case "sc-floating-menu-download":
        TOCHelpers.getLayerInfo(layerInfo, (result) => {
          if (result.featureType.name === "Assessment Parcel")
            helpers.showMessage(
              "Sťahovanie",
              "Sťahovanie nedostupné"
            );
          else {
            helpers.addAppStat("Download", layerInfo.name);
            if (helpers.isMobile()) {
              window.emitter.emit("setSidebarVisiblity", "CLOSE");
              helpers.showWindow(
                <LayerInfoApp
                  layerURL={result.featureType.fullUrl}
                  params={result.requestParams}
                  showDownload={1}
                />
              );
            } else {
              helpers.showWindow(
                <LayerInfoApp
                  layerURL={result.featureType.fullUrl}
                  params={result.requestParams}
                  showDownload={1}
                />
              );
            }
          }
        });
        break;
      default:
        break;
    }
    helpers.addAppStat("Layer Options", action);
  };
  render() {
    var evtClone = Object.assign({}, this.props.evt);

    return (
      <Portal>
        <FloatingMenu
          key={helpers.getUID()}
          buttonEvent={evtClone}
          autoY={true}
          //item={this.props.info}
          onMenuItemClick={(action) =>
            this.onMenuItemClick(action, this.props.layerInfo)
          }
          styleMode={helpers.isMobile() ? "left" : "right"}
        >
          {this.props.layerInfo.layer.values_.queryable === true && (
            <MenuItem
              className={
                this.props.layerInfo.metadataUrl !== undefined &&
                  this.props.layerInfo.metadataUrl !== null
                  ? "sc-floating-menu-toolbox-menu-item"
                  : "sc-hidden"
              }
              key="sc-floating-menu-metadata"
            >
              <FloatingMenuItem
                //    imageName={"metadata.png"}
                imageName={"metadata"}
                label="Metadáta"
              />
            </MenuItem>
          )}

          {
            this.props.layerInfo.layer.values_.userLayer !== true &&
            // this.props.layerInfo.layer.values_.queryable === true && 
            !EXCLUDED_ATT_TAB.includes(this.props.layerInfo.layer.values_.tocDisplayName) && (
              <MenuItem className="sc-floating-menu-toolbox-menu-item" key="sc-floating-menu-attribute-table">
                <FloatingMenuItem
                  // imageName={"metadata.png"}
                  imageName={"table"}
                  label="Atribútová tabuľka"
                />
              </MenuItem>
            )
          }

          {
            //Imported from MTO TOC
            /*<MenuItem className={layerInfo.layer instanceof VectorLayer ? "sc-floating-menu-toolbox-menu-item" : "sc-hidden"} key="sc-floating-menu-export-layer">
            <FloatingMenuItem imageName={"download.png"} label="Download visible features" />
          </MenuItem>
          */
          }
          <MenuItem
            className={
              (this.props.layerInfo.metadataUrl !== undefined &&
                this.props.layerInfo.metadataUrl !== null) ||
                this.props.layerInfo.layer instanceof VectorLayer
                ? "sc-floating-menu-toolbox-menu-item"
                : "sc-hidden"
            }
            key="sc-floating-menu-zoom-to-layer"
          >
            <FloatingMenuItem
              imageName={"zoom"}
              //   imageName={"zoom-in.png"}
              label="Priblížiť na vrstvu"
            />
          </MenuItem>
          {/* <MenuItem className="sc-floating-menu-toolbox-menu-item" key="sc-floating-menu-zoom-to-layer-visible">
						<FloatingMenuItem imageName={"zoom-in.png"} label="Zoom to Visible Scale" />
					</MenuItem> */}
          <MenuItem
            className={
              this.props.layerInfo.canDownload
                ? "sc-floating-menu-toolbox-menu-item"
                : "sc-hidden"
            }
            key="sc-floating-menu-download"
          >
            <FloatingMenuItem
              imageName={"download"}
              // imageName={"download.png"}
              label="Download"
            />
          </MenuItem>
          <MenuItem
            className={
              this.props.layerInfo.layer.get("userLayer")
                ? "sc-floating-menu-toolbox-menu-item"
                : "sc-hidden"
            }
            key="sc-floating-menu-remove-layer"
          >
            <FloatingMenuItem
              imageName={"eraser"}
              label="Vymazať vrstvu"
            />
          </MenuItem>
          <MenuItem className="sc-layers-slider sc-layers-slider-label" key="sc-floating-menu-opacity">
            <FloatingMenuItem
              imageName={"visibility"}
              label="Viditeľnosť vrstvy"
            />
            <SliderWithTooltip
              tipFormatter={this.sliderTipFormatter}
              max={1}
              min={0}
              step={0.05}
              defaultValue={this.props.layerInfo.opacity}
              onChange={(evt) => this.onSliderChange(evt, this.props.layerInfo)}
              onAfterChange={(evt) =>
                this.onSliderAfterChange(evt, this.props.layerInfo)
              }
            />
          </MenuItem>
        </FloatingMenu>
      </Portal>
    );
  }
}
export default LayerOptionsMenu;

// SLIDER
const SliderWithTooltip = createSliderWithTooltip(Slider);
